<template>
    <div class="topcode-wechat-inspect-item" @click="$router.push('/inspect/device/'+inspect.state+'/'+inspect.id)">
        <div class="top">
            <div :class="'flex-center-y auto-width-8 state  inspect-state-'+inspect.state">{{stateDICT}}</div>
            <div class="flex-center-y time ">{{time}}</div>
        </div>
        <div class="body">
            <div class="content">
                <div class="flex-center-y left">
                    <img src="./images/order.png"/>
                    <div class="name" style="font-size: 14px">
                        <div class="title-small">{{inspect.name}}</div>
                        <div>{{inspect.unitName}}</div>
                    </div>
                </div>
                <div class="flex-center right">
                    <span>详情</span>
                    <van-icon name="arrow"/>
                </div>
            </div>
            <div class="footer">
                <div style=" color: #1890ff;">
                    <span>总数:</span>
                    <span>{{inspect.total}}</span>
                </div>
                <div style="color:#52c41a">
                    <span>完成:</span>
                    <span>{{ inspect.finishTotal }}</span>
                </div>
                <div style="color:#f5222d">
                    <span>报修:</span>
                    <span>{{ inspect.repairTotal }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as DICT from "@/utils/dict"
    import moment from "moment"

    export default {
        components: {},
        props: {
            inspect: {type: Object, required: true}
        },
        data() {
            return {};
        },
        computed: {
            userLists() {
                const userList = this.inspect.userList;
                return (userList || []).map(item => item.realName).join(",")
            },
            stateDICT() {
                return DICT.getValue('INSPECT_TSAK_STATE', this.inspect.state)
            },
            time() {
                const {startTime, finishTime} = this.inspect
                return `${moment(startTime).format('YYYY-MM-DD')} 至 ${moment(finishTime).format('YYYY-MM-DD')} `
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    };
</script>

<style lang="less" scoped>


    .topcode-wechat-inspect-item {
        width: 100%;
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;

        & > .top {
            color: #fff;
            display: flex;
            height: 23px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                border-radius: 8px 0px 0px 0px;
            }
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                justify-content: flex-end;

            }
        }

        & > .body {
            border: 1px #cccccc solid;
            border-radius: 0 0 8px 8px;
            display: flex;
            flex-direction: column;
            & > .content {
                /*padding: 2px 8px;*/
                width: 100%;
                display: flex;

                & > .right {
                    font-size: 14px;
                    font-weight: 500;
                    // color: #e89c05;
                    color: #fa7d2d;
                    width: 75px;
                }
                & > .left {
                    padding: 5px;
                    display: flex;
                    width: calc(100% - 10px);
                    & > img {
                        width: 50px;
                        height: 50px;
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                }
            }
            & > .footer {
                border-top: 1px solid #bbb;
                width: 100%;
                height: 22px;
                display: flex;
                align-items: center;
                justify-content: space-around;
            }
        }
    }
</style>
